import React, { useCallback, useEffect, useState } from "react";
import { PenTool, Trash2, Upload } from "lucide-react";
import { fetchUserSignature, practiceApi } from "../lib/practiceApi";

export const SignatureUpload = ({ userId, name, testid = "signature" }) => {
  const [preview, setPreview] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [flash, setFlash] = useState("");

  const load = useCallback(async () => {
    const url = await fetchUserSignature(userId);
    setPreview(current => { if (current) URL.revokeObjectURL(current); return url; });
  }, [userId]);

  useEffect(() => { load(); }, [load]);

  async function upload(file) {
    if (!file) return;
    setBusy(true); setError(""); setFlash("");
    try {
      const form = new FormData();
      form.append("file", file);
      await practiceApi(`/users/${userId}/signature`, { method: "POST", body: form });
      await load();
      setFlash("Timbro salvato: sarà usato nei documenti dei cantieri di cui è responsabile");
    } catch (err) { setError(err.message); } finally { setBusy(false); }
  }

  async function remove() {
    setBusy(true); setError(""); setFlash("");
    try {
      await practiceApi(`/users/${userId}/signature`, { method: "DELETE" });
      await load();
      setFlash("Timbro rimosso: verrà usato quello dello studio");
    } catch (err) { setError(err.message); } finally { setBusy(false); }
  }

  return <div className="settings-asset" data-testid={`${testid}-card`}>
    <div className="settings-asset-head">
      <strong><PenTool size={15} /> Timbro e firma personale</strong>
      <small>{preview ? `Timbro personale attivo${name ? ` · ${name}` : ""}` : "Nessun timbro personale: si usa quello dello studio"}</small>
    </div>
    <div className="settings-asset-preview">
      {preview ? <img src={preview} alt="Timbro personale" data-testid={`${testid}-preview`} />
        : <span className="muted">Nessuna immagine</span>}
    </div>
    <p className="settings-asset-hint">Viene inserito nei verbali e nelle lettere dei cantieri di cui è responsabile. Negli altri documenti resta il timbro dello studio.</p>
    {error && <div className="error" role="alert" data-testid={`${testid}-error`}>{error}</div>}
    {flash && <div className="flash" data-testid={`${testid}-flash`}>{flash}</div>}
    <div className="settings-asset-actions">
      <label className="settings-upload" data-testid={`${testid}-upload`}>
        <Upload size={15} />{busy ? "Caricamento…" : "Carica timbro"}
        <input type="file" accept="image/png,image/jpeg,image/webp" hidden disabled={busy}
          onChange={e => upload(e.target.files?.[0])} />
      </label>
      {preview && <button type="button" className="settings-asset-reset" disabled={busy}
        data-testid={`${testid}-remove`} onClick={remove}><Trash2 size={14} />Rimuovi</button>}
    </div>
  </div>;
};
